import { render } from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=template&id=512d37f7"
import script from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadgeCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__